import { render, staticRenderFns } from "./Pictures.vue?vue&type=template&id=6dece63d&"
import script from "./Pictures.vue?vue&type=script&lang=ts&"
export * from "./Pictures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports